<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <div>
        <div class="page-title mb-2">รายการประวัติผู้ใช้บริการ</div>
      </div>
      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-icon="ic:baseline-search"
              @onChange="keyword = $event"
              @onEnter="getData()"
            ></TextField>
          </div>
        </div>
      </div>
    </div>
    <divcard titled class="">
      <div class="card-part-orange2 font-20 font-w-700">ข้อมูลผู้ใช้บริการ</div>
      <div class='mt-5'>
        <div class="d-flex w-100">
          <div class="d-flex w-100">
            <div class="w-100">ชื่อ-สกุล</div>
            <div class="w-100">{{ form.name }}</div>
          </div>
          <div class="d-flex w-100">
            <div class="w-100">ที่อยู่</div>
            <div class="w-100">{{ form.address }}</div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex w-100">
            <div class="w-100">ประเภทผู้ใช้บริการ</div>

            <div class="w-100">{{ form.customer_type }}</div>
          </div>
          <div class="d-flex w-100">
            <div class="w-100">สถานะ</div>

            <div class="w-100">{{ form.status === 1 ? "ใช้งาน" : "ปิดใช้งาน" }}</div>
          </div>
        </div>
      </div>
    </divcard>
    <divcard class="mt-10">
      <div class="font-20 font-w-700">รายการประวัติการใช้บริการ</div>
      <table class="custom-table mt-5">
        <thead>
          <tr>
            <th class="text-center" width="5%">ลำดับ</th>
            <th class="text-center" width="40%">รายละเอียด</th>
            <th class="text-center" width="15%">แผนงาน</th>
            <th class="text-center" width="20%">วันที่ให้บริการ</th>
            <th class="text-center" width="10%">สถานะ</th>
          </tr>
        </thead>
        <tbody v-if="form?.histories?.data && form.histories.data.length">
        <tr v-for="(history, index) in form.histories.data" :key="index">
          <td class="text-center">{{ index + 1 }}</td>
          <td class="text-center">{{ history.history }}</td>
          <td class="text-center">{{ history.plan }}</td>
          <td class="text-center">{{ toDateFormat2(history.date) }}</td>
          <td class="text-center">{{ history.status }}</td>
          <!-- <td class="text-center">{{ history.status === 1 ? "ใช้บริการ" : "ไม่ใช้บริการ" }}</td> -->
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td class="text-center" colspan="5">ไม่มีข้อมูล</td>
        </tr>
      </tbody>
      </table>
      <div class='mt-8 d-flex  justify-end' >
        <v-pagination
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          :total-visible="7"
          @input="getData"
        ></v-pagination>
    </div>
    </divcard>
    <div  class="d-flex justify-space-between mt-10" >
      <div style='width:96px;'>

      </div>
 
      <div>
        <Button @onClick="routeBack" theme="2">ย้อนกลับ</Button>
      </div>
    
    </div>
   
  </div>
</template>

<script>
import TextField from "@/components/input/TextField.vue";
import TextArea from "@/components/input/TextArea.vue";
import SelectBox from "@/components/input/SelectBox";
import Button from "@/components/input/Button";
import { toDateFormat2 } from "@/plugins/global-funcs";

export default {
  name: "UserServiceHistoryId",
  components: {
    TextField,
    Button,
    SelectBox,
    TextArea,
  },
  data() {
    return {
      toDateFormat2,
      keyword: "",
      status: "",
      form: {
      },
      users: [
      ],
      histories: [
      ],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page) {
      const payload = {
        id: this.$route.params.id,
        page: page || this.paginate.current_page,
        keyword: this.keyword,
      };
      let res = await this.$apiFire("UserServiceHistory/show",payload);
      console.log('res',res)
      if (res) {
        this.form = res.data;
        this.paginate = {
            total: res.data.histories.total,
            per_page: res.data.histories.per_page,
            current_page: res.data.histories.current_page,
            last_page: res.data.histories.last_page,
        };
      }
    },
    routeBack() {
      this.$router.push({
        name: "UserServiceHistory",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.custom-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  th,
  td {
    border: 1px solid var(--theme-color-eight);
    padding: 10px;
  }

  th {
    background-color: #ffffff;
    text-align: center;
    font-weight: bold;
  }

  .text-center {
    text-align: center;
  }
}
.w-100 {
  width: 100%;
}
</style>
